//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import editor from "vue2-ace-editor";
import AQMonacoEditor from "@/components/Generics/AQMonacoEditor/AQMonacoEditor.vue";
import AQMonacoDiffEditor from "@/components/Generics/AQMonacoEditor/AQMonacoDiffEditor.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import QFabricModal from "@/components/q-fabric-modal.vue";
import QfLayers from "@/components/UserInterfaces/right-container/qf-layers.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
/* eslint-disable import/no-extraneous-dependencies */
// import "brace/mode/javascript";
// import "brace/mode/text";
// import "brace/mode/json";
// import "brace/theme/tomorrow";
import roboI from "@/assets/images/robo2_16px.svg";
import closeI from "@/assets/images/close_24px.svg";
import roboOrg from "@/assets/images/robo_orange.svg";
import { mapState, mapActions, mapGetters } from "vuex";
import fnSignatures from "./fn-signature.json";

export default {
    name: "QfMScriptEditor",
    components: { QFabricModal, AQMonacoEditor, QfLayers, AQDialog, AQInput, AQButton, AQTooltip, AQMonacoDiffEditor, AQDropdown }, /* editor */
    props: {
        content: { type: String, default: "" },
        event: { type: String, default: "" },
        clear: { type: Boolean, default: false }
    },
    data() {
        return {
            splitterModel: 100,
            isFullscreen: false,
            isDarkMode: false,
            showLayoutTree: false,
            localShow: true,
            localContent: null,
            copyLocalContent: "",
            validating: false,
            errors: null,
            hasErrors: false,
            showDialog: false,
            promptOpened: false,
            promptInput: null,
            roboIcon: `img:${roboI}`,
            roboIconOrange: `img:${roboOrg}`,
            closeIcon: `img:${closeI}`,
            initialScriptDraft: null,
            draftMode: false,
            rspAiDraft: null,
            diffEditor: false,
            diffValue: "",
            loadingPromptState: false,
            typePrompt: [{ label: this.$t("generic.add"), value: "add" }],
            selectedAiTypeLabel: "add",
            callStopped: false,
            typeOptions: [
                { label: this.$t("generic.add"), value: "add" },
                { label: this.$t("generic.modify"), value: "modify" }
            ],
            showErrorContainer: false,
            errorLabelToShow: "",
            typeAI: "OAI"
        };
    },
    computed: {
        ...mapState("components", ["components", "properties", "activeComponent", "currentInterfaceProperties"]),
        ...mapGetters("admin", ["featuresByTenant"]),
        ...mapState("main", ["interfaceDirty"]),
        size() {
            return this.isFullscreen ? "100vw" : "max(50vw,720px)";
        },
        showAiAssistant() {
            return this.featuresByTenant.find(element => element.code === "ENABLE_AI" && element.enabled);
        },
        getIconBtn() {
            return this.promptOpened ? this.closeIcon : this.roboIconOrange;
        },
        actions() {
            // return [{ label: "Update", name: "set", disable: this.validating || this.hasErrors }];
            return [{ label: "Update", name: "set" }];
        },
        title() {
            return `Script editor${this.event ? ` - ${this.event}` : ""}`;
        },
        getPlaceholder() {
            return this.$t("userInterface.promptAiPlaceholder", { action: this.typePrompt[0].label.toLowerCase() });
        },
        suggestions() {
            const suggestionsList = [];
            Object.entries(this.properties).forEach(([, value]) => {
                if (value.__generics.code) {
                    suggestionsList.push({ label: value.__generics.code, value: value.__generics.code });
                }
            });

            return suggestionsList;
        },
        globalContent() {
            const currentProps = this.properties[this.activeComponent];
            const inSegment = this.hasParentSegment();
            const constList = [];
            const lines = [];

            // eslint-disable-next-line default-case
            switch (this.event) {
                case "onInit": {
                    const hasValues = this.components[currentProps.__component].values;
                    const isSegment = !hasValues && this.components[currentProps.__component].namespace;

                    constList.push({ name: "initialValue", isConst: true, isObj: isSegment }, { name: "value" });
                    if (hasValues) {
                        constList.push({ name: "extendedValues", isConst: true, isObj: true });
                    }

                    if (inSegment) {
                        constList.push(
                            { name: "index", isConst: true }, { name: "parent", isConst: true }, { name: "path", isConst: true }
                        );
                        // if (isSegment) {} else {}
                    }
                    break;
                }
                case "onChildInit": {
                    constList.push(
                        { name: "index", isConst: true },
                        { name: "parent", isConst: true },
                        { name: "path", isConst: true },
                        { name: "initialValue", isConst: true, isObj: true },
                        { name: "value" }
                    );
                    break;
                }
                case "onChange": {
                    const isSegment = this.components[currentProps.__component].namespace;

                    constList.push({ name: "oldValue", isConst: true }, { name: "newValue", isConst: true });
                    if (this.components[currentProps.__component].values) {
                        constList.push(
                            { name: "oldExtendedValues", isConst: true, isObj: true },
                            { name: "newExtendedValues", isConst: true, isObj: true }
                        );
                    }
                    if (inSegment) {
                        constList.push(
                            { name: "index", isConst: true }, { name: "parent", isConst: true }, { name: "path", isConst: true }
                        );
                    } else if (isSegment) {
                        constList.push(
                            { name: "index", isConst: true }, { name: "parent", isConst: true }, { name: "path", isConst: true }
                        );
                    }
                    break;
                }
                case "onChildChange": {
                    constList.push(
                        { name: "triggers", isConst: true, isArray: true },
                        { name: "oldValue", isConst: true, isObj: true },
                        { name: "newValue", isConst: true, isObj: true },
                        { name: "path", isConst: true },
                        { name: "index", isConst: true }
                    );
                    break;
                }
                case "onSave":
                case "onSubmit": {
                    constList.push(
                        { name: "value", isConst: true },
                        { name: "submit", isConst: true },
                        { name: "action", isConst: true },
                        { name: "error" }
                    );
                    break;
                }
            }

            constList.forEach(item => {
                const { isConst = false, name, isArray = false, isObj = false } = item;
                if (isArray) {
                    lines.push(`${isConst ? "const" : "let"} ${name} = []`);
                } else if (isObj) {
                    lines.push(`${isConst ? "const" : "let"} ${name} = {}`);
                } else {
                    lines.push(`${isConst ? "const" : "let"} ${name};`);
                }
            });
            lines.push(...Object.values(fnSignatures));

            return lines.join("\r\n");
        }
    },
    watch: {
        content: {
            handler(val) {
                this.localContent = val || "";
            },
            immediate: true
        }
    },
    mounted() {
        if (this.showAiAssistant && this.showAiAssistant.enabled && !this.interfaceDirty) {
            this.getFeatureDetailsByCode("ENABLE_AI").then((rsp) => {
                this.typeAI = rsp.data && rsp.data.extraData.aiProvider === "AOAI" ? "AOAI" : "OAI";
                this.aiEmbeddings({ id: this.currentInterfaceProperties.id, type: this.typeAI }).catch(() => {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("admin.labs.apiAuthentificationError")
                    });
                });
            });
        }
    },
    beforeMount() {
        this.isDarkMode = localStorage.getItem("monacoIsDark") === "true";
    },
    methods: {
        ...mapActions("components", ["askAi", "aiEmbeddings"]),
        ...mapActions("admin", ["getFeatureDetailsByCode"]),
        openClosePrompt() {
            this.promptOpened = !this.promptOpened;
            if (!this.promptOpened) {
                this.promptInput = "";
                this.errorLabelToShow = "";
                this.showErrorContainer = false;
                if (this.draftMode) {
                    this.draftMode = false;
                }
                this.callStopped = true;
                this.diffEditor = false;
                this.$root.$emit("emitNewValueMonaco", this.initialScriptDraft);
            }
        },
        draftModeAction(fromRej) {
            this.localContent = fromRej ? this.initialScriptDraft : this.diffValue;
            this.$root.$emit("emitNewValueMonaco", this.localContent);
            if (!fromRej) {
                this.promptInput = "";
            }
            this.diffEditor = false;
            this.draftMode = false;
        },
        stopAICall() {
            this.callStopped = true;
        },
        sendToAi() {
            if (this.promptInput) {
                this.loadingPromptState = true;
                this.showErrorContainer = false;
                this.errorLabelToShow = "";
                document.getElementsByClassName("prompt-container")[0].classList.add("before");
                const payload = {
                    prompt: this.promptInput,
                    script: this.typePrompt[0].value === "modify" ? this.localContent : "",
                    guiId: this.currentInterfaceProperties.id
                };
                this.askAi({ data: payload, type: this.typeAI }).then((data) => {
                    if (data.data.code === 200) {
                        if (document.getElementsByClassName("prompt-container")[0]) {
                            document.getElementsByClassName("prompt-container")[0].classList.remove("before");
                        }
                        if (!this.callStopped) {
                            this.draftMode = true;
                            this.initialScriptDraft = this.localContent;
                            if (this.typePrompt[0].value === "add") {
                                this.diffValue = this.localContent ? this.localContent.concat(data.data.message) : data.data.message;
                            } else {
                                this.diffValue = data.data.message;
                            }
                            this.diffEditor = true;
                        }
                        this.callStopped = false;
                    } else if (data.data.code !== 200) {
                        this.showErrorContainer = true;
                        this.errorLabel(data.data.code);
                    }
                    this.loadingPromptState = false;
                }).catch(() => {
                    this.showErrorContainer = true;
                    this.errorLabel("error");
                    this.loadingPromptState = false;
                });
            }
        },
        errorLabel(code) {
            if (code !== 200 || code === "error") {
                this.errorLabelToShow = this.$t("admin.labs.apiAuthentificationError");
            }
        },
        nodeClick(node) {
            const { key } = node;

            if (key !== "body") {
                const { editor } = this.$refs;
                const properties = this.properties[key];
                const { code } = properties.__generics;
                if (code) {
                    editor.insertText(code);
                    this.$nextTick(() => editor.setFocus());
                }
            }
        },
        showCommandPalette() {
            const { editor } = this.$refs;
            editor.showCommandPalette();
        },
        toggleLayoutTree() {
            this.showLayoutTree = !this.showLayoutTree;
            if (this.showLayoutTree) {
                this.splitterModel = this.isFullscreen ? 75 : 60;
            } else {
                this.splitterModel = 100;
            }
        },
        toggleDarkMode() {
            this.isDarkMode = !this.isDarkMode;
            localStorage.setItem("monacoIsDark", this.isDarkMode.toString());
        },
        setFullscreen() {
            this.$nextTick(() => {
                this.isFullscreen = !this.isFullscreen;
                if (this.showLayoutTree) {
                    this.splitterModel = this.isFullscreen ? 75 : 60;
                }
            });
        },
        showErrors() {
            const { editor } = this.$refs;
            editor.showViewProblems();
        },
        hasParentSegment() {
            const guid = this.activeComponent;
            let parent = this.properties[guid] && this.properties[guid].parent ? this.properties[guid].parent : null;
            let hasParentSegment = false;
            let currentProps;

            while (parent && !hasParentSegment) {
                currentProps = this.properties[parent];
                hasParentSegment = this.components[currentProps.__component].namespace;
                parent = currentProps.parent;
            }

            return hasParentSegment;
        },
        modalAction(action) {
            if (action.simple === "hide") {
                const changesInContent = this.copyLocalContent !== JSON.stringify(this.localContent);
                if (changesInContent) {
                    this.showDialog = true;
                } else {
                    this.localShow = ["action_backdrop", "action_esc"].includes(action.detailed);
                }
            } else if (action.simple === "action") {
                if (action.detailed === "set") {
                    this.$emit("update", this.localContent);
                    this.localShow = false;
                }
            }
        },
        closeModal() {
            this.localShow = false;
            this.showDialog = false;
        },
        clearLocalContent() {
            this.localContent = null;
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        // checkAnnotations(annotations) {
        //     this.hasErrors = annotations.some(annotation => annotation.type === "error");
        //     this.validating = false;
        // },
        // editorInit(editorInstance) {
        editorInit() {
            // editorInstance.focus();
            // editorInstance.getSession().on("changeAnnotation", () => {
            //     this.checkAnnotations(editorInstance.getSession().getAnnotations());
            // });
            this.copyLocalContent = JSON.stringify(this.localContent);
        },
        contentChange() {
            this.validating = true;
        }
    }
};
